/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setEcgTypeMethodOptions } from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getEcgTypeMethodOptions() {
  const serviceId = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const ecgTypeMethod = yield call([vitalsService, vitalsService.getEcgTypeMethod])
    const { entity } = ecgTypeMethod
    yield put(setEcgTypeMethodOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getRhythmOptions() error: ${e}`))
  }
}

export function* getEcgTypeMethodOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getEcgTypeMethodOptions)
}
